module.exports = "<lfwms-result-data-table [searchService]=\"searchService\" [tableMode]=\"searchService.displayMode\" (buttonActionHandler)=\"buttonService.handleMainButtonPanelActionsForTable($event, widgetConfig.id)\"></lfwms-result-data-table>"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/components/widget/ship-ref-status-tracking-widget/ship-ref-status-tracking-widget.html
// module id = ../../../../../src/app/shared/components/widget/ship-ref-status-tracking-widget/ship-ref-status-tracking-widget.html
// module chunks = main